module.exports = __webpack_public_path__ + "static/media/autocomplete-gif.b8e3b472.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/autocomplete-gif.gif
// module id = 510
// module chunks = 0